import React from 'react'
import { Drawer, IconButton } from 'rsuite'
import CloseIcon from '@rsuite/icons/Close'
import style from './languageOverlay.module.scss'
import { ContentContainer } from '@/components/styles'
import LanguageSelector from '@/components/themes/subaru/language/languageSelector'
import useTranslation from '@/hooks/useTranslation'

const LanguageOverlay = ({ open, onClose, locale, changeLocale, languages }) => {
  const t = useTranslation()

  return (
    <Drawer open={open} onClose={onClose} placement="top" size="xs" className={style.languageOverlay}>
      <Drawer.Header closeButton={false} className={style.drawerHeader}>
        <IconButton
          icon={<CloseIcon />}
          appearance="subtle"
          size="sm"
          onClick={onClose}
          aria-label={t('close_language_dialog', 'Close language selection dialog')}
          className={style.closeButton}
        />
        <Drawer.Title className={style.drawerTitle}>
          {t('header_select_language', 'Select Website Language')}
        </Drawer.Title>
      </Drawer.Header>
      <Drawer.Body className={style.drawerBody}>
        <ContentContainer>
          <LanguageSelector languages={languages} locale={locale} changeLocale={changeLocale} />
        </ContentContainer>
      </Drawer.Body>
    </Drawer>
  )
}

export default LanguageOverlay
